export default __webpack_public_path__ + "static/media/property_650.43b3ee6a.png";